import { Button, Group, Text } from '@mantine/core';
import React, { useEffect, useState } from 'react';

const CHUNK_ERROR_EVENT = 'flowboard-chunk-error';

export function NewVersionBar() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const handler = () => setShow(true);
    window.addEventListener(CHUNK_ERROR_EVENT, handler);
    return () => window.removeEventListener(CHUNK_ERROR_EVENT, handler);
  }, []);

  if (!show) return null;

  const handleRefresh = () => {
    window.location.reload();
  };

  return (
    <Group
      position="apart"
      px="md"
      py="xs"
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 9999,
        backgroundColor: 'var(--mantine-color-blue-9)',
        color: '#fff',
        boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
      }}
      role="alert"
      aria-live="polite"
    >
      <Text size="sm" weight={500}>
        A new version is available. Refresh to get the latest.
      </Text>
      <Button variant="white" color="dark" size="xs" onClick={handleRefresh}>
        Refresh
      </Button>
    </Group>
  );
}

export function dispatchChunkError(): void {
  window.dispatchEvent(new CustomEvent(CHUNK_ERROR_EVENT));
}
